<template>
  <div class="results">
    <Header header="results"></Header>
    <div class="result">
      <b-container class="content-normal">
        <section v-if="getWinner" class="winner">
          <h2 v-if="this.language === 'fi'" class="mb-4">{{ $t('results.winner-title') }} {{ getWinner.title }}</h2>
          <h2 v-else-if="this.language === 'sv'" class="mb-4">{{ getWinner.title }} {{$t('results.winner-title') }}</h2>
          <Wave/>
          <img class="w-100 mt-4 mb-5" :src="getWinner.image">
          <p>{{ getWinner.description }}</p>
        </section>
        <section v-else class="winner">
          <h2 v-if="this.language === 'fi'" class="mb-4">{{ $t('results.winner-title') }} {{ getShareLocation['title'] }}</h2>
          <h2 v-else-if="this.language === 'sv'" class="mb-4">{{ getShareLocation['title'] }} {{$t('results.winner-title') }}</h2>
          <Wave/>
          <img class="w-100 mt-4 mb-5" :src="getShareLocation['image']">
          <p>{{ getShareLocation['description'] }}</p>
          <button class="btn mt-5" @click="restartMachine">{{ $t('results.take-test-btn') }}</button>
        </section>

        <section v-if="getWinner" class="has-result">
          <section class="share-result">
            <div v-if="this.contest" class="thank-you">
              <h2 class="py-5 m-0">{{ $t('results.form.thank-you') }}</h2>
            </div>
            <div v-else>
              <button v-b-modal.contest-form class="btn">{{ $t('results.raffle-btn') }}</button>
            </div>

            <b-modal id="contest-form" centered size="xl" hide-footer>
              <b-container class="content-narrow px-0 text-center">
                <h2 class="pb-3">{{ $t('results.form.heading') }}</h2>
                <p class="pb-3">{{ $t('results.form.info') }}</p>
                <b-form @submit="onSubmit" class="contact-form">
                  <b-row>
                    <b-col cols="md-6">
                      <b-form-input
                        v-model=form.firstName
                        type="text"
                        size="lg"
                        required
                        :placeholder="$t('results.form.first-name')"
                      ></b-form-input>
                    </b-col>
                    <b-col cols="md-6">
                      <b-form-input
                        v-model=form.lastName
                        type="text"
                        size="lg"
                        required
                        :placeholder="$t('results.form.last-name')"
                      ></b-form-input>
                    </b-col>
                  </b-row>
                  <b-form-input
                    v-model=form.residence
                    size="lg"
                    required
                    :placeholder="$t('results.form.residence')"
                  ></b-form-input>
                  <b-form-input
                    v-model=form.phoneNr
                    size="lg"
                    type="tel"
                    :placeholder="$t('results.form.phone')"
                  ></b-form-input>
                  <b-form-input
                    v-model=form.email
                    size="lg"
                    type="email"
                    required
                    :placeholder="$t('results.form.email')"
                  ></b-form-input>
                  <p class="float-right font-italic">{{ $t('results.form.required') }}</p>
                  <b-form-checkbox
                    v-model=form.gdpr
                    size="lg"
                    required
                    name="consent"
                  >{{ $t('results.form.gdpr') }}
                  </b-form-checkbox>
                  <b-form-checkbox
                    v-model=form.rules
                    size="lg"
                    required
                    name="marketing"
                  >{{ $t('results.form.rules-1') }} <a target="_blank" :href="share + '/' + this.language + '/rules/'">{{
                      $t('results.form.rules-link')
                    }}</a> {{ $t('results.form.rules-2') }} <a target="_blank"
                                                               :href="$t('results.form.rules-link-2-url')">{{
                      $t('results.form.rules-link-2')
                    }}</a> {{ $t('results.form.rules-3') }}
                  </b-form-checkbox>
                  <button type="submit" class="btn submit-btn my-5">{{ $t('results.form.send') }}</button>
                </b-form>
              </b-container>
            </b-modal>

            <h2 class="share-result-title pt-5">{{ $t('results.share-result-title') }}</h2>
            <Wave/>
            <div class="share-icons">
              <a target="_blank" class="mx-2" :href="'https://www.facebook.com/sharer.php?u=' + shareUrl()">
                <Facebook/>
              </a>
              <a target="_blank" class="mx-2"
                 :href="'https://www.linkedin.com/shareArticle?url=' + share + '/' + this.language + ' | ' + this.meta[this.language].title + this.meta[this.language][this.$route.params.tulos].title">
                <LinkedIn/>
              </a>
              <a target="_blank" class="mx-2" :href="'https://twitter.com/share?url=' + shareUrl()">
                <Twitter/>
              </a>
              <a target="_blank" class="mx-2"
                 :href="'https://api.whatsapp.com/send?text=' + share + '/' + this.language + ' | ' + this.meta[this.language].title + this.meta[this.language][this.$route.params.tulos].title">
                <WhatsApp/>
              </a>
              <a target="_blank" class="mx-2"
                 :href="'mailto:?subject=' + share + '/' + this.language + ' | ' + this.meta[this.language].title + this.meta[this.language][this.$route.params.tulos].title">
                <Email/>
              </a>
            </div>
          </section>

          <section v-if="getWinner.sponsor_text" class="sponsor">
            <div class="vertical-decobar"></div>
            <b-row>
              <b-col md="3" class="d-flex justify-content-center pb-3">
                <div class="img-container">
                  <img v-object-fit :src="getWinner.sponsor_image" :alt="getWinner.sponsor_alt">
                </div>
              </b-col>
              <b-col md="9" class="text-md-left">
                <p>{{ getWinner.sponsor_text }}</p>
                <p class="font-weight-bold">- {{ getWinner.sponsor_name }}</p>
                <a :href="getWinner.link" target="_blank">{{ $t('results.read-more-sponsor') }}</a>
              </b-col>
            </b-row>
          </section>

          <section class="runnerups">
            <h2 class="runnerups-title mb-4">{{ $t('results.runnerups-title') }}</h2>
            <b-row>
              <b-col md="6" class="mb-3">
                <div class="img-container">
                  <img v-object-fit :src="getSecond.image">
                </div>
                <div class="decobar"></div>
                <h3 class="my-3">{{ getSecond.title }}</h3>
                <p class="pb-4">{{ shortDesc(getSecond.description) }}</p>
                <a :href="getSecond.link" target="_blank">{{ $t('results.read-more-text') }}</a>
              </b-col>
              <b-col md="6" class="mb-3">
                <div class="img-container">
                  <img v-object-fit :src="getThird.image">
                </div>
                <div class="decobar"></div>
                <h3 class="my-3">{{ getThird.title }}</h3>
                <p class="pb-4">{{ shortDesc(getThird.description) }}</p>
                <a :href="getThird.link" target="_blank">{{ $t('results.read-more-text') }}</a>
              </b-col>
            </b-row>
          </section>

          <Realtors/>
          <button class="btn mb-5" @click="restartMachine">{{ $t('results.start-over') }}</button>
        </section>
      </b-container>
    </div>
    <Footer/>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import Wave from '@/assets/svg/wave.svg'
import Facebook from '@/assets/svg/unelmakone--facebook.svg'
import Email from '@/assets/svg/unelmakone-email.svg'
import LinkedIn from '@/assets/svg/unelmakone-linkedin.svg'
import Twitter from '@/assets/svg/unelmakone-twitter.svg'
import WhatsApp from '@/assets/svg/unelmakone-whatsapp.svg'
import Realtors from '@/components/Realtors'
import router from '@/router'
export default {
  name: 'Result',
  components: { Realtors, Footer, Header, Wave, Facebook, Email, LinkedIn, Twitter, WhatsApp },
  props: {
    section: String
  },
  data () {
    return {
      form: {
        firstName: '',
        lastName: '',
        residence: '',
        phoneNr: '',
        email: '',
        gdpr: false,
        rules: false
      },
      meta: {
        fi: {
          globalTitle: 'Raaseporin Unelmakone',
          title: 'Kerroin Raaseporin Unelmakoneelle haaveistani, ja ne saattavat toteutua täällä: ',
          shareBase: 'https://unelma.raasepori.fi',
          mustio: {
            title: 'Mustio',
            content: 'Jos kaipaat elämääsi linnoja ja loistoa, luontoa ja rauhallisuutta, Mustio voisi olla sopiva koti juuri sinulle.'
          },
          pohja: {
            title: 'Pohja',
            content: 'Pohja on keskiaikainen kirkonkylä, joka vuosisadasta toiseen houkuttelee suuren määrän ihmisiä idyllisiin ruukkeihinsa.'
          },
          karjaa: {
            title: 'Karjaa',
            content: 'Karjaa on kaiken keskellä, liikenteen solmukohta josta on helppo liikkua itään ja länteen, tai vaikka Suomen eteläisimpään kärkeen Hankoon.'
          },
          tammisaari: {
            title: 'Tammisaari',
            content: 'Tammisaari on meren syleilemä, keskiaikainen kylä toreineen ja rantoineen, ravintoloineen ja puistoineen. Tapahtumia järjestetään vilkkaasti.'
          },
          fiskars: {
            title: 'Fiskars',
            content: 'Fiskaria kauniimpaa kotikylää on vaikeaa kuvitella, mutta vieläkin enemmän ilahduttaa fiskarilaisuuden ydin: ennakkoluuloton yhdessä tekeminen ja luovuus.'
          },
          pinjainen: {
            title: 'Pinjainen',
            content: 'Pinjaisissa aika tuntuu pysähtyneen mutta joki virtaa ja kaikki palvelut ovat vain kivenheiton päässä. Ruukin keskusta on ollut näyttämönä monille tapahtumille.'
          },
          snappertuna: {
            title: 'Snappertuna',
            content: 'Snappertunassa sijaitsee Raaseporin keskiaikaisen linnan rauniot. Täällä on myös hienoja rantoja, havuntuoksuisia metsiä ja upeaa luontoa.'
          },
          tenhola: {
            title: 'Tenhola',
            content: 'Houkuttaako luonto, mutta pelkäät eristäytyväsi liikaa? Tenholassa riittää yhdistyksia ja seuroja, kesäteatteri, juustola ja omaa jäätelöä.'
          },
          bromarv: {
            title: 'Bromarv',
            content: 'Jos saaristo ja kuulaat kesäyöt herättävät sielusi laulamaan, on Bromarv oikea paikka sinulle. Loputtomasti merenrantaa ja Padvan hieno hiekka.'
          }
        },
        sv: {
          globalTitle: 'Raseborgs Drömmaskin',
          title: 'Raseborgs drömmaskin rekommenderade mig: ',
          shareBase: 'https://drom.raseborg.fi',
          mustio: {
            title: 'Svartå',
            content: 'Önskar du slott, glans, natur och lugn i ditt liv? Då kunde Svartå vara ett hem just för dig.'
          },
          pohja: {
            title: 'Pojo',
            content: 'I Pojo finns både trygga och fridfulla lantliga miljöer samtidigt som bruken erbjuder högklassiga restauranger och oförglömliga upplevelser.'
          },
          karjaa: {
            title: 'Karis',
            content: 'Karis är en central knutpunkt för både Raseborg och hela Västra Nyland. I den barnvänliga staden finner du såväl natur som kultur och idrott.'
          },
          tammisaari: {
            title: 'Ekenäs',
            content: 'Ekenäs är den havsnära medeltida staden med torg och stränder, restauranger och parker. Kulturutbudet är stort och evenemangskalendern full.'
          },
          fiskars: {
            title: 'Fiskars',
            content: 'Fiskars är drömplatsen för alla som uppskattar estetik och gemenskap. Serviceutbudet är i särklass för en liten by.'
          },
          pinjainen: {
            title: 'Billnäs',
            content: 'I Billnäs har du möjlighet att uppleva en idyllisk bruksmiljö och hitta ditt drömboende t.ex. bland historiska bruksbyggnader invid Svartån.'
          },
          snappertuna: {
            title: 'Snappertuna',
            content: 'Har du alltid drömt om ett eget slott? Förutom Raseborgs medeltida slottsruiner finns här också fina stränder, gröna skogar och fantastisk natur.'
          },
          tenhola: {
            title: 'Tenala',
            content: 'I Tenala får du både naturens stillhet och en bygemenskap. Här finns gott om föreningar och grupper, sommarteater och lokaltidning, osteri och egen glass.'
          },
          bromarv: {
            title: 'Bromarv',
            content: 'Om skärgård och ljusa sommarnätter är ljuv musik för dina öron då är Bromarv det rätta stället för dig. Strand så långt ögat kan nå och Padvas fina sand.'
          }
        }
      }
    }
  },
  metaInfo () {
    return {
      title: this.meta[this.language][this.$route.params.tulos].title,
      titleTemplate: '%s | ' + this.meta[this.language].globalTitle,
      meta: [
        {
          name: 'twitter:title',
          content: this.meta[this.language].title + this.meta[this.language][this.$route.params.tulos].title,
          vmid: 'twitter:title'
        },
        {
          name: 'twitter:description',
          content: this.meta[this.language][this.$route.params.tulos].content,
          vmid: 'twitter:description'
        },
        {
          name: 'twitter:image',
          content: this.metaImage(),
          vmid: 'twitter:image'
        },
        {
          property: 'og:title',
          content: this.meta[this.language].title + this.meta[this.language][this.$route.params.tulos].title,
          vmid: 'og:title'
        },
        {
          property: 'og:type',
          content: 'article',
          vmid: 'og:type'
        },
        {
          property: 'og:url',
          content: this.meta[this.language].shareBase + this.sharePath(),
          vmid: 'og:url'
        },
        {
          property: 'og:image',
          content: this.metaImage(),
          vmid: 'og:image'
        },
        {
          property: 'og:description',
          content: this.meta[this.language][this.$route.params.tulos].content,
          vmid: 'og:description'
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['getLocations', 'getWinner', 'getSecond', 'getThird', 'getRealtors']),
    ...mapState(['contest', 'language']),
    share () {
      return window.location.origin
    },
    getShareLocation () {
      return this.$store.getters.getSharedLocation(this.$route.params.tulos)
    }
  },
  methods: {
    shortDesc (text) {
      const regex = /^[^.]+\.(?= [A-Z])/
      const str = text

      let m
      if ((m = regex.exec(str)) !== null) {
        return m[0]
      }
      return text
    },
    restartMachine () {
      this.$store.dispatch('resetMachine')
      router.push({ name: 'home' })
    },
    onSubmit (evt) {
      evt.preventDefault()
      // console.debug(form)
      this.$store.dispatch('submitForm', {
        firstName: this.form.firstName,
        lastName: this.form.lastName,
        residence: this.form.residence,
        phoneNr: this.form.phoneNr,
        email: this.form.email,
        gdpr: this.form.gdpr,
        rules: this.form.rules,
        winner: this.getWinner.title
      })
    },
    metaImage () {
      for (const l of this.$store.state.locations) {
        if (this.$route.params.tulos === l.slug) {
          return l.image
        }
      }
    },
    shareUrl () {
      return window.location.href
    },
    sharePath () {
      return window.location.pathname
    }
  },
  watch: {
    contest (newValue, oldValue) {
      if (newValue === true) {
        this.$bvModal.hide('contest-form')
      }
    }
  }
}
</script>
